<template>
  <DropdownTarget v-slot="{ visible, show, hide }">
    <BasicButton @click="show" appearance="context" size="m">
      <SvgIcon size="24" icon="dots" />
    </BasicButton>
    <TransitionFade>
      <BasicDropdown v-if="visible" @close="hide">
        <BasicButton
          :href="bpConstructorLinkParams.href"
          target="_blank"
          appearance="dropdown-list-item"
        >
          {{ bpConstructorLinkParams.label }}
        </BasicButton>

        <BasicButton
          v-for="link in adminLinks"
          :key="link.href"
          :href="getLinkHref(link)"
          @click="handleAdminLinkClick(link)"
          appearance="dropdown-list-item"
        >
          {{ link.title }}
        </BasicButton>
      </BasicDropdown>
    </TransitionFade>
  </DropdownTarget>
</template>

<script>
import { notify } from 'src/notify.js';
import { cancellableRequest } from 'src/services/api.js';

import BasicButton from 'src/components/BasicButton/BasicButton.vue';
import BasicDropdown from 'src/components/BasicDropdown/BasicDropdown.vue';
import DropdownTarget from 'src/components/DropdownTarget/DropdownTarget.vue';
import SvgIcon from 'src/components/icons/SvgIcon/SvgIcon.vue';
import TransitionFade from 'src/components/transitions/TransitionFade/TransitionFade.vue';

export default {
  name: 'CompanySidebarContextMenu',
  components: {
    TransitionFade,
    DropdownTarget,
    BasicButton,
    BasicDropdown,
    SvgIcon,
  },
  props: {
    hasBrandedProfile: {
      type: Boolean,
      required: true,
    },
    companyAlias: {
      type: String,
      required: true,
    },
    adminLinks: {
      type: Array,
      required: true,
    },
  },
  emits: ['report', 'update:user'],
  methods: {
    getLinkHref(link) {
      if (link.method === 'GET' && link.href.startsWith('http')) {
        return link.href;
      }

      return null;
    },
    handleAdminLinkClick(link) {
      if (this.getLinkHref(link)) return;

      cancellableRequest({
        baseURL: window.location.origin,
        url: link.href,
        method: link.method,
        headers: {
          Accept:
            '*/*;q=0.5, text/javascript, application/javascript, application/ecmascript, application/x-ecmascript',
        },
      })
        .then(() => {
          notify({
            message: 'Синхронизация запущена.',
            type: 'notice',
          });
        })
        .catch(() => {
          notify({
            message: 'Что-то пошло не так',
            type: 'error',
          });
        });
    },
  },
  computed: {
    bpConstructorLinkParams() {
      if (this.hasBrandedProfile) {
        return {
          href: `/companies/${this.companyAlias}/bp/edit`,
          label: 'Редактировать бренд. профиль',
        };
      }

      return {
        href: `/companies/${this.companyAlias}/bp/create`,
        label: 'Создать бренд. профиль',
      };
    },
  },
};
</script>
